(function () {
  function moneyFromCents(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || window.theme?.moneyFormat);
    }
    return (cents / 100).toFixed(0);
  }

  function findVariant(product, selectedOptions) {
    return (product.variants || []).find(function (variant) {
      return selectedOptions.every(function (val, i) {
        return variant['option' + (i + 1)] === val;
      });
    });
  }

  function getSectionRoot(sectionId, fromNode) {
    return (
      document.getElementById('MainProduct-' + sectionId) ||
      document.getElementById('ProductInfo-' + sectionId)?.closest('product-info') ||
      fromNode?.closest('product-info') ||
      document.querySelector('product-info[data-section="' + sectionId + '"]')
    );
  }

  function parseImagesAttr(raw) {
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }

  function setImgSrc(img, url) {
    if (!img || !url) return;
    img.src = url;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  }

  function updateGalleryFromUrls(sectionId, urls, fromNode) {
    if (!urls || !urls.length) return false;
    var sectionRoot = getSectionRoot(sectionId, fromNode);
    if (!sectionRoot) return false;

    var bm7Main = document.getElementById('bm7-mainimg-' + sectionId);
    if (bm7Main) {
      setImgSrc(bm7Main, urls[0]);
      var thumbs = sectionRoot.querySelectorAll('#bm7-thumbs-' + sectionId + ' img');
      thumbs.forEach(function (t, i) {
        if (!urls[i]) return;
        setImgSrc(t, urls[i].replace('width=1200', 'width=200'));
        t.setAttribute('data-full', urls[i]);
        t.classList.toggle('on', i === 0);
      });
      document.dispatchEvent(new CustomEvent('bm7:product-updated'));
      return true;
    }

    var wrapper = sectionRoot.querySelector('.product__media-wrapper');
    if (!wrapper) return false;

    var slides = wrapper.querySelectorAll('.product__media-item');
    if (slides.length) {
      slides.forEach(function (slide, idx) {
        if (!urls[idx]) return;
        slide.querySelectorAll('img').forEach(function (img) {
          setImgSrc(img, urls[idx]);
        });
      });
      return true;
    }

    var updated = 0;
    wrapper.querySelectorAll('img').forEach(function (img) {
      if (updated >= urls.length) return;
      if (img.closest('[data-bm7-compose]')) return;
      setImgSrc(img, urls[updated]);
      updated += 1;
    });
    return updated > 0;
  }

  function syncSubmitButton(sectionId, root, available, priceHtml) {
    var sectionRoot = getSectionRoot(sectionId, root);
    var submit =
      root.querySelector('#bm7-submit-' + sectionId) ||
      document.getElementById('ProductSubmitButton-' + sectionId) ||
      sectionRoot?.querySelector('[name="add"]') ||
      document.querySelector('[name="add"]');
    if (!submit) return;

    var soldOutLabel = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    var addLabel = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    var productForm = submit.closest('product-form');

    if (productForm && typeof productForm.toggleSubmitButton === 'function') {
      productForm.toggleSubmitButton(!available, available ? undefined : soldOutLabel);
    } else {
      if (available) {
        submit.disabled = false;
        submit.removeAttribute('disabled');
      } else {
        submit.disabled = true;
        submit.setAttribute('disabled', 'disabled');
      }
      submit.removeAttribute('aria-disabled');

      var submitText = submit.querySelector('span');
      if (submitText && !submitText.classList.contains('loading__spinner')) {
        submitText.textContent = available ? 'Add to Bag — ' + priceHtml : 'Sold Out';
      }
    }

    if (window.bm7SyncStickyAtc) window.bm7SyncStickyAtc(sectionId);
  }

  function syncBuyRowFromFreshSection(sectionId, freshRoot, curRoot) {
    if (!freshRoot || !curRoot) return;

    var freshSubmit = freshRoot.querySelector('#ProductSubmitButton-' + sectionId);
    var curSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (freshSubmit && curSubmit) {
      var freshLabel = freshSubmit.querySelector('span');
      var curLabel = curSubmit.querySelector('span');
      if (freshLabel && curLabel) curLabel.textContent = freshLabel.textContent;

      if (freshSubmit.hasAttribute('disabled')) {
        curSubmit.setAttribute('disabled', 'disabled');
        curSubmit.disabled = true;
      } else {
        curSubmit.removeAttribute('disabled');
        curSubmit.disabled = false;
      }
      curSubmit.removeAttribute('aria-disabled');
    }

    var freshInput =
      freshRoot.querySelector('form[action*="/cart/add"] [name="id"]') ||
      freshRoot.querySelector('.product-variant-id');
    var curInput =
      curRoot.querySelector('form[action*="/cart/add"] [name="id"]') ||
      curRoot.querySelector('.product-variant-id');
    if (freshInput && curInput) {
      curInput.value = freshInput.value;
      curInput.disabled = freshInput.disabled;
    }

    if (window.bm7SyncStickyAtc) window.bm7SyncStickyAtc(sectionId);
  }

  function swapMediaFromSection(sectionId, handle, fromNode) {
    var fetchUrl =
      '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(fetchUrl)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshRoot =
          doc.getElementById('MainProduct-' + sectionId) ||
          doc.querySelector('product-info') ||
          doc.querySelector('.product');
        var curRoot = getSectionRoot(sectionId, fromNode);
        if (!freshRoot || !curRoot) return;

        var freshMedia = freshRoot.querySelector('.product__media-wrapper');
        var curMedia = curRoot.querySelector('.product__media-wrapper');
        if (freshMedia && curMedia) {
          curMedia.innerHTML = freshMedia.innerHTML;
        }

        var freshPrice = freshRoot.querySelector('#price-' + sectionId);
        var curPrice = document.getElementById('price-' + sectionId);
        if (freshPrice && curPrice) {
          curPrice.innerHTML = freshPrice.innerHTML;
        }

        var freshTitle = freshRoot.querySelector('.product__title h1, .product__title .h1');
        var curTitle = curRoot.querySelector('.product__title h1, .product__title .h1');
        if (freshTitle && curTitle) {
          curTitle.textContent = freshTitle.textContent;
        }

        curRoot.setAttribute('data-url', '/products/' + handle);
        syncBuyRowFromFreshSection(sectionId, freshRoot, curRoot);
        document.dispatchEvent(new CustomEvent('bm7:product-updated', { detail: { handle: handle } }));
      });
  }

  function syncStickyUnitPrice(sectionId, priceRaw, compareRaw) {
    if (!sectionId || priceRaw == null || priceRaw === '') return;
    var bar = document.querySelector(
      '[data-bm7-sticky-atc][data-section-id="' + sectionId + '"]'
    );
    if (!bar) return;
    var unit = parseInt(priceRaw, 10);
    if (isNaN(unit)) return;
    bar.setAttribute('data-unit-price', String(unit));
    var compare = parseInt(compareRaw, 10);
    bar.setAttribute(
      'data-compare-unit-price',
      !isNaN(compare) && compare > unit ? String(compare) : '0'
    );
  }

  function updatePriceNodes(root, priceHtml, priceRaw, compareHtml, available, compareRaw) {
    var sectionId = root.getAttribute('data-section-id');
    var priceEl =
      root.querySelector('#bm7-price-' + sectionId) ||
      document.getElementById('price-' + sectionId) ||
      root.querySelector('.pdp__price') ||
      getSectionRoot(sectionId, root)?.querySelector('.price');

    syncStickyUnitPrice(sectionId, priceRaw, compareRaw);

    /* Prefer qty/packing-aware total (length + premium box) when available. */
    if (sectionId && typeof window.bm7UpdateProductQtyPrice === 'function' && priceRaw != null) {
      window.bm7UpdateProductQtyPrice(sectionId);
    } else if (priceEl) {
      if (compareHtml) {
        priceEl.innerHTML =
          '<span class="was">' +
          compareHtml +
          '</span>' +
          priceHtml +
          '<span class="save">Sale</span>';
      } else if (priceEl.id === 'price-' + sectionId || priceEl.classList.contains('price')) {
        /* Dawn price block — leave to section swap when possible */
      } else {
        priceEl.innerHTML = priceHtml;
      }
    }

    var totalForBtn = priceHtml;
    if (sectionId) {
      var stickyPrice = document.querySelector(
        '[data-bm7-sticky-atc][data-section-id="' + sectionId + '"] [data-sticky-atc-price]'
      );
      if (stickyPrice && stickyPrice.textContent) totalForBtn = stickyPrice.textContent.trim();
    }
    syncSubmitButton(sectionId, root, available, totalForBtn);
  }

  function updateVariantInput(root, variantId, available) {
    var sectionRoot = getSectionRoot(root.getAttribute('data-section-id'), root);
    var idInput =
      sectionRoot?.querySelector('.product-variant-id') ||
      sectionRoot?.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('.product-variant-id');
    if (!idInput) return;
    idInput.value = variantId;
    idInput.disabled = !available;
  }

  function setActiveOption(buttons, activeBtn) {
    buttons.forEach(function (btn) {
      var on = btn === activeBtn;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function stripComposePagination(root) {
    if (!root) return;

    root.querySelectorAll('.slider-buttons, .slider-counter, [data-compose-pagination]').forEach(function (el) {
      el.remove();
    });

    var scroll = root.querySelector('[data-compose-scroll]');
    if (scroll && scroll.nextElementSibling && scroll.nextElementSibling.classList.contains('slider-buttons')) {
      scroll.nextElementSibling.remove();
    }

    root.querySelectorAll('[data-compose-sibling], [data-compose-option]').forEach(function (btn) {
      btn.hidden = false;
      btn.style.removeProperty('display');
      btn.classList.remove('is-hidden');
    });
  }

  function initCompose(root) {
    if (!root || root.dataset.composeReady) return;
    root.dataset.composeReady = '1';

    stripComposePagination(root);

    var info = root.closest('.product__info-container') || root.closest('.pdp__info');
    if (info) {
      info.querySelectorAll('.product-form__buttons .slider-buttons, .product-form__buttons .slider-counter').forEach(function (el) {
        el.remove();
      });
    }

    var selectedLabel = root.querySelector('[data-compose-selected]');
    var sectionId = root.getAttribute('data-section-id');

    root.querySelectorAll('[data-compose-sibling]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable') || btn.disabled) return;
        if (btn.classList.contains('is-active')) return;

        var handle = btn.getAttribute('data-handle');
        var url = btn.getAttribute('data-url');
        var color = btn.getAttribute('data-color');
        var price = btn.getAttribute('data-price');
        var compare = btn.getAttribute('data-compare');
        var variantId = btn.getAttribute('data-variant-id');
        var available = btn.getAttribute('data-available') === 'true';
        var images = parseImagesAttr(btn.getAttribute('data-images'));

        /* Length variants live on each colour product — hard navigate so
           Size options + prices refresh for the selected colour. */
        if (root.getAttribute('data-has-length') === 'true' && url) {
          window.location.href = url;
          return;
        }

        setActiveOption(root.querySelectorAll('[data-compose-sibling]'), btn);
        if (selectedLabel) selectedLabel.textContent = color;

        updatePriceNodes(
          root,
          price,
          btn.getAttribute('data-price-raw'),
          compare,
          available,
          btn.getAttribute('data-compare-raw')
        );
        updateVariantInput(root, variantId, available);
        updateGalleryFromUrls(sectionId, images, root);

        if (url && window.history && window.history.replaceState) {
          window.history.replaceState({}, '', url);
        }

        if (handle && sectionId) {
          swapMediaFromSection(sectionId, handle, root).catch(function () {
            /* gallery already updated from data-images */
          });
        }
      });
    });

    var productJsonEl = root.querySelector('[data-compose-product-json]');
    if (!productJsonEl) return;

    var product = JSON.parse(productJsonEl.textContent);
    var selected = product.options.map(function (_, i) {
      return product.variants[0]['option' + (i + 1)];
    });

    root.querySelectorAll('[data-compose-option].is-active').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      selected[idx] = btn.getAttribute('data-value');
    });

    var keepColorLabel = root.getAttribute('data-sibling-mode') === 'true';

    function applyVariant(variant) {
      if (!variant) return;
      var price = moneyFromCents(variant.price);
      var compare =
        variant.compare_at_price > variant.price
          ? moneyFromCents(variant.compare_at_price)
          : '';
      updatePriceNodes(
        root,
        price,
        variant.price,
        compare,
        variant.available,
        variant.compare_at_price > variant.price ? variant.compare_at_price : 0
      );
      updateVariantInput(root, variant.id, variant.available);
      if (selectedLabel && !keepColorLabel) selectedLabel.textContent = variant.title;

      root.querySelectorAll('[data-compose-option]').forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        var on = selected[idx] === value;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    root.querySelectorAll('[data-compose-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        selected[idx] = value;

        root
          .querySelectorAll('[data-compose-option][data-option-index="' + idx + '"]')
          .forEach(function (peer) {
            peer.classList.toggle('is-active', peer === btn);
            peer.setAttribute('aria-selected', peer === btn ? 'true' : 'false');
          });

        applyVariant(findVariant(product, selected));
      });
    });

    applyVariant(findVariant(product, selected));
  }

  function boot() {
    document.querySelectorAll('[data-bm7-compose]').forEach(initCompose);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
